import React, { useEffect, useState } from "react";
import { getAllCollegePagination, getAllCourse } from "../../Services/MasterService";
import { toast } from "react-toastify";
import { createCourseAndCollege } from "../../Services/CollegeService";
import { useNavigate } from "react-router-dom";

const AddCollegeAndCourse = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        id: "",
        college_id: "",
        course_id: "",
        avg_tution_fee: "",
        preferred_gender: "",
        rank: "",
        has_flagship: "",
        mode_of_delivery: "",
        course_url: "",
        fee_currency: "",
        fee_category: "",
        fee_duration: "",
        total_students: "",
        approved_intake: "",
        acceptance_rate: "",
        status: "",
        fee_value: ""
    });
    const [loader, setLoader] = useState(false);
    const [college, setCollege] = useState([]);
    const [course, setCourse] = useState([]);
    const navigate = useNavigate();

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await createCourseAndCollege(reqData);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    const getAllCollegeCall = async () => {
        let { ok, data } = await getAllCollegePagination({});
        if (ok) {
            setCollege(data?.records);
        }
    };

    const getAllCourseCall = async () => {
        let { ok, data } = await getAllCourse({});
        if (ok) {
            setCourse(data?.records);
        }
    };

    const redirect = (url) => {
        navigate(url, { state: reqData })
    };

    useEffect(() => {
        getAllCollegeCall();
        getAllCourseCall();
        if (data?.data) {
            const { id, college_id, course_id, avg_tution_fee, preferred_gender, rank, has_flagship, mode_of_delivery, course_url, fee_currency, fee_category, fee_duration, total_students, acceptance_rate, approved_intake, status, fee_value } = data?.data;
            setReqData({ id, college_id, course_id, avg_tution_fee, preferred_gender, rank, has_flagship, mode_of_delivery, course_url, fee_currency, fee_category, fee_duration, total_students, acceptance_rate, approved_intake, status, fee_value });
        }
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add College And Course" : "Edit College And Course"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>College</label>
                                            <select required value={reqData?.college_id} onChange={(e) => handleChange("college_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value={""} selected>Select College</option>
                                                {college?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Course</label>
                                            <select required value={reqData?.course_id} onChange={(e) => handleChange("course_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value={""} selected>Select Course</option>
                                                {course?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Preferred Gender</label>
                                            <select required value={reqData?.preferred_gender} onChange={(e) => handleChange("preferred_gender", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select Preferred Gender</option>
                                                <option value={"male"}>Male</option>
                                                <option value={"female"}>Female</option>
                                                <option value={"others"}>Others</option>
                                                <option value={"any"}>Any</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Average Fees</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Average Fees"
                                                required
                                                value={reqData?.avg_tution_fee}
                                                onChange={(e) => handleChange("avg_tution_fee", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Fees Value</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Fees Value"
                                                required
                                                value={reqData?.fee_value}
                                                onChange={(e) => handleChange("fee_value", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Rank</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Rank"
                                                required
                                                value={reqData?.rank}
                                                onChange={(e) => handleChange("rank", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Flagship Course</label>
                                            <select required value={reqData?.has_flagship} onChange={(e) => handleChange("has_flagship", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value="" selected>Select</option>
                                                <option value={true}>Yes</option>
                                                <option value={false}>No</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Mode Of Delivery</label>
                                            <select required value={reqData?.mode_of_delivery} onChange={(e) => handleChange("mode_of_delivery", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value={""} selected>Select</option>
                                                <option value={"Physical"}>Physical</option>
                                                <option value={"Online"}>Online</option>
                                                <option value={"Blended"}>Blended</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Course URL</label>
                                            <input
                                                type="url"
                                                className="form-control"
                                                placeholder="Course url"
                                                value={reqData?.course_url}
                                                onChange={(e) => handleChange("course_url", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Fee Currency</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Fee Currency"
                                                required
                                                value={reqData?.fee_currency}
                                                onChange={(e) => handleChange("fee_currency", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Fee Category</label>
                                            <select required value={reqData?.fee_category} onChange={(e) => handleChange("fee_category", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value={""} selected>Select</option>
                                                <option value={"General Category"}>General Category</option>
                                                <option value={"International Student"}>International Student</option>
                                                <option value={"Management Quota"}>Management Quota</option>
                                                <option value={"Other"}>Other</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Fee Duration</label>
                                            <select required value={reqData?.fee_duration} onChange={(e) => handleChange("fee_duration", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value={""} selected>Select</option>
                                                <option value={"Semester"}>Semester</option>
                                                <option value={"Trimester"}>Trimester</option>
                                                <option value={"Quarter"}>Quarter</option>
                                                <option value={"Annual"}>Annual</option>
                                                <option value={"Full Course"}>Full Course</option>
                                                <option value={"1st Yr"}>1st Yr</option>
                                                <option value={"2nd Yr"}>2nd Yr</option>
                                                <option value={"3rd Yr"}>3rd Yr</option>
                                                <option value={"4th Yr"}>4th Yr</option>
                                                <option value={"5th Yr"}>5th Yr</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Total Students</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Total Students"
                                                required
                                                value={reqData?.total_students}
                                                onChange={(e) => handleChange("total_students", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Approved Intake</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Approved Intake"
                                                required
                                                value={reqData?.approved_intake}
                                                onChange={(e) => handleChange("approved_intake", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Acceptance Rate</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Acceptance Rate"
                                                required
                                                value={reqData?.acceptance_rate}
                                                onChange={(e) => handleChange("acceptance_rate", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Status</label>
                                            <select required value={reqData?.status} onChange={(e) => handleChange("status", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value={""} selected>Select</option>
                                                <option value={"save"}>Save</option>
                                                <option value={"publish"}>Publish</option>
                                                <option value={"unpublish"}>Unpublish</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn me-2"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                                {reqData?.id &&
                                    <button
                                        className="btn bank-save-btn me-2"
                                        disabled={loader}
                                        onClick={() => redirect("/college-course/exam")}
                                    >
                                        Exams
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddCollegeAndCourse;